import React from 'react';
import { Link } from 'react-router-dom';

// Mobile (APK) Login — full-width form, large tap targets, brand on top.
export default function LoginMobile({ vm }) {
  const { mobile, setMobile, password, setPassword, remember, setRemember, busy, err, autoChecking, submit } = vm;

  if (autoChecking) {
    return (
      <div className="auth-mobile">
        <div className="auth-mobile-brand">Mehfil by Smartify</div>
        <div className="muted" style={{ marginTop: 12, fontSize: 14, textAlign: 'center' }}>Signing you in…</div>
      </div>
    );
  }

  return (
    <div className="auth-mobile">
      <div className="auth-mobile-brand">Mehfil by Smartify</div>
      <div className="muted auth-mobile-sub">Event organiser sign in</div>
      <form onSubmit={submit} className="auth-mobile-form">
        <label className="field">Mobile Number
          <input type="tel" inputMode="numeric" maxLength={10} value={mobile} placeholder="10-digit mobile"
            onChange={(e) => setMobile(e.target.value)} />
        </label>
        <label className="field">Password
          <input type="password" value={password} placeholder="Password"
            onChange={(e) => setPassword(e.target.value)} />
        </label>
        <label className="auth-mobile-check">
          <input type="checkbox" checked={remember} onChange={(e) => setRemember(e.target.checked)} />
          Keep me signed in on this phone
        </label>
        {err && <div className="auth-mobile-err">{err}</div>}
        <button className="btn primary auth-mobile-btn" disabled={busy}>
          {busy ? 'Signing in…' : 'Sign In'}
        </button>
      </form>
      <div className="auth-mobile-links">
        <Link to="/register">Create an account</Link>
        <Link to="/invite">I am a guest — view my invitation</Link>
      </div>
    </div>
  );
}
